
import { TranslationsByLanguage } from './types';

export type NavigationTranslationKey =
  | 'sidebar.browseLicensedContent'
  | 'sidebar.channels'
  | 'sidebar.playlists'
  | 'sidebar.clips'
  | 'sidebar.creatorHub'
  | 'sidebar.derivatives'
  | 'sidebar.creators'
  | 'sidebar.mySpace'
  | 'sidebar.dashboard'
  | 'sidebar.createDerivative'
  | 'sidebar.publishCreation'
  | 'sidebar.myFavorites'
  | 'sidebar.adminSpace'
  | 'sidebar.manageChannels'
  | 'sidebar.manageUsers'
  | 'sidebar.manageLicenses'
  | 'sidebar.manageDerivatives'
  | 'sidebar.manageChallenges'
  | 'sidebar.analytics';

export const navigationTranslations: TranslationsByLanguage = {
  fr: {
    'sidebar.browseLicensedContent': 'Parcourir le contenu sous licence',
    'sidebar.channels': 'Chaînes',
    'sidebar.playlists': 'Playlists',
    'sidebar.clips': 'Clips',
    'sidebar.creatorHub': 'Espace Créateurs',
    'sidebar.derivatives': 'Créations',
    'sidebar.creators': 'Créateurs',
    'sidebar.mySpace': 'Mon Espace',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.createDerivative': 'Créer une oeuvre dérivée',
    'sidebar.publishCreation': 'Publier une création',
    'sidebar.myFavorites': 'Mes Favoris',
    'sidebar.adminSpace': 'Espace Admin',
    'sidebar.manageChannels': 'Gérer les chaînes',
    'sidebar.manageUsers': 'Gérer les utilisateurs',
    'sidebar.manageLicenses': 'Gérer les licences',
    'sidebar.manageDerivatives': 'Gérer les œuvres dérivées',
    'sidebar.manageChallenges': 'Gérer les challenges',
    'sidebar.analytics': 'Analytique',
  },
  en: {
    'sidebar.browseLicensedContent': 'Browse Licensed Content',
    'sidebar.channels': 'Channels',
    'sidebar.playlists': 'Playlists',
    'sidebar.clips': 'Clips',
    'sidebar.creatorHub': 'Creator Hub',
    'sidebar.derivatives': 'Creations',
    'sidebar.creators': 'Creators',
    'sidebar.mySpace': 'My Space',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.createDerivative': 'Create Derivative',
    'sidebar.publishCreation': 'Publish Creation',
    'sidebar.myFavorites': 'My Favorites',
    'sidebar.adminSpace': 'Admin Space',
    'sidebar.manageChannels': 'Manage Channels',
    'sidebar.manageUsers': 'Manage Users',
    'sidebar.manageLicenses': 'Manage Licenses',
    'sidebar.manageDerivatives': 'Manage Derivatives',
    'sidebar.manageChallenges': 'Manage Challenges',
    'sidebar.analytics': 'Analytics',
  }
};

export const navigation = {
  fr: {
    sidebar: {
      browseLicensedContent: 'Parcourir le contenu sous licence',
      channels: 'Chaînes',
      playlists: 'Playlists',
      clips: 'Clips',
      creatorHub: 'Espace Créateurs',
      derivatives: 'Créations',
      creators: 'Créateurs',
      mySpace: 'Mon Espace',
      dashboard: 'Dashboard',
      createDerivative: 'Créer une oeuvre dérivée',
      publishCreation: 'Publier une création',
      myFavorites: 'Mes Favoris',
      adminSpace: 'Espace Admin',
      manageChannels: 'Gérer les chaînes',
      manageUsers: 'Gérer les utilisateurs',
      manageLicenses: 'Gérer les licences',
      manageDerivatives: 'Gérer les œuvres dérivées',
      manageChallenges: 'Gérer les challenges',
      analytics: 'Analytique',
    },
  },
  en: {
    sidebar: {
      browseLicensedContent: 'Browse Licensed Content',
      channels: 'Channels',
      playlists: 'Playlists',
      clips: 'Clips',
      creatorHub: 'Creator Hub',
      derivatives: 'Creations',
      creators: 'Creators',
      mySpace: 'My Space',
      dashboard: 'Dashboard',
      createDerivative: 'Create Derivative',
      publishCreation: 'Publish Creation',
      myFavorites: 'My Favorites',
      adminSpace: 'Admin Space',
      manageChannels: 'Manage Channels',
      manageUsers: 'Manage Users',
      manageLicenses: 'Manage Licenses',
      manageDerivatives: 'Manage Derivatives',
      manageChallenges: 'Manage Challenges',
      analytics: 'Analytics',
    }
  }
};
